<div class="row">
  <div class="col-md-4">
    <ngx-skeleton-loader count="1" [theme]="{
      'border-radius': '4px',
      'height': '500px',
      'width': '340px'}">
    </ngx-skeleton-loader>
    <div class="item">
      <ngx-skeleton-loader count="5"></ngx-skeleton-loader>
    </div>
  </div>

  <div class="col-md-8">
    <div class="item-body">
      <ngx-skeleton-loader count="10"></ngx-skeleton-loader>
    </div>
  </div>
</div>